import { UseKlydoMutationOptions } from '../../hooks/useKlydoMutation';
import uploadsApiClient, {
  UploadLoopFileInput,
  UploadResponse,
} from '../../api/uploads';
import useUploadMutation from './useUploadMutation';

const useUploadKlydoLoopMutation = (
  options: Omit<
    UseKlydoMutationOptions<
      UploadResponse,
      UploadLoopFileInput,
      { previousUploadStatus: UploadResponse | undefined }
    >,
    'onSuccess' | 'onSettled'
  > & {
    onSuccess?: (response: UploadResponse) => void;
    onSettled?: (response: UploadResponse | undefined, error: unknown) => void;
  } = {},
) => {
  const uploadKlydoLoopWithPreset = (input: UploadLoopFileInput) => {
    return uploadsApiClient.uploadKlydoLoop({
      ...input,
    });
  };

  return useUploadMutation(
    uploadKlydoLoopWithPreset,
    'upload-klydo-loop',
    options,
  );
};

export default useUploadKlydoLoopMutation;
